import React from 'react'

import type { NextPage, NextPageContext } from 'next'

import AppLayout from '@microsites/components/AppLayout'
import { ChannelPage } from '@microsites/components/Channel/ChannelPage'
import DirectVideo from '@microsites/components/Discover/DirectVideo'
import type { IMicrositePageProps } from '@microsites/types'
import { getMicrositeInitialProps } from '@microsites/utils/microsites/getMicrositeInitialProps'

/**
 * Watch page for video detail (/watch?fw_video={videoId})
 */
const WatchPage: NextPage<IMicrositePageProps> = (props) => {
  if (props.isCustomDomain) {
    return <ChannelPage {...props} />
  } else {
    return (
      <AppLayout>
        <DirectVideo {...props} />
      </AppLayout>
    )
  }
}

WatchPage.getInitialProps = async (context: NextPageContext) => {
  return await getMicrositeInitialProps(context)
}

export default WatchPage
